import { render, staticRenderFns } from "./Resetpassword.vue?vue&type=template&id=e7097e84&scoped=true"
import script from "./Resetpassword.vue?vue&type=script&lang=js"
export * from "./Resetpassword.vue?vue&type=script&lang=js"
import style0 from "./Resetpassword.vue?vue&type=style&index=0&id=e7097e84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7097e84",
  null
  
)

export default component.exports